import React, { Component } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";

// REDUX
import { Provider } from "react-redux";
import store from "./redux_store";
import { MANUFACTURER } from "./AppConfig";

TimeAgo.addDefaultLocale(en);

export const getCookie = (name) => {
    return document.cookie.split("; ").reduce((r, v) => {
        const parts = v.split("=");
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, "");
};

class ReduxWrapper extends Component {
    render() {
        let page_loader = document.getElementById("page_loader");
        page_loader.style.display = "none";

        window.debug = false;
        window.test = false;
        window.beta = false;
        window.brand = "DEFAULT";
        window.FIELDERS = false;
        window.LYSAGHT = false;

        const SF_User = getCookie("SF_user");
        window.OFFLINE_MODE = false;
        if (
            (SF_User.includes("kevinchan") || SF_User.includes("michael.abdo")) &&
            window.location.href.includes("static")
        )
            window.OFFLINE_MODE = true;

        if (window.location.href.includes("preprod")) window.beta = true;
        if (window.location.href.includes("localhost")) window.debug = true;
        if (
            window.location.href.includes("localhost") ||
            window.location.href.includes("test.") ||
            window.location.href.includes("designcloud.australiaeast")
        )
            window.test = true;
        if (window.location.href.toLowerCase().includes("centenary") || SF_User.includes(".cen")) {
            window.brand = "Fielders";
            window.FIELDERS = true;
            window.LYSAGHT = false;
            document.title = MANUFACTURER.Fielders.SoftwareName;
            const shortcutIcon = document.querySelector("link[rel='shortcut icon']");
            const icon = document.querySelector("link[rel*='icon']");
            if (shortcutIcon) shortcutIcon.href = "/app/favicon_debug.ico";
            if (icon) icon.href = "/app/favicon_debug.ico";
        } else if (window.location.href.toLowerCase().includes("lysaght") || SF_User.includes(".lld")) {
            window.brand = "Lysaght";
            window.FIELDERS = false;
            window.LYSAGHT = true;
            document.title = MANUFACTURER.Lysaght.SoftwareName;

            if (window.test) {
                document.querySelector("link[rel='shortcut icon']").href = "/app/favicon_lld_test.png";
                document.querySelector("link[rel*='icon']").href = "/app/favicon_lld_test.png";
            } else {
                document.querySelector("link[rel='shortcut icon']").href = "/app/favicon_lld.png";
                document.querySelector("link[rel*='icon']").href = "/app/favicon_lld.png";
            }
        }

        window.USE_EPRICE = window.LYSAGHT;

        var tabID = sessionStorage.tabID ? sessionStorage.tabID : (sessionStorage.tabID = Math.random());

        window.session_id = tabID;

        if (process.env.NODE_ENV === "production") {
            console.log(
                "%cWe are happy to have you as a registered user! However, this tool is used for the production and development of this website. It is against your terms of service with Bluescope to inspect, deconstruct, reverse engineer or modify the source code of this website in any way.",
                "color:blue; font-size:20px"
            );
            if (window.location.href.includes("test.") || window.debug || window.test) {
            } else {
                if (
                    SF_User &&
                    (SF_User.startsWith("kevinchan") ||
                        SF_User.includes("michael.abdo") ||
                        SF_User.includes("diego.portela"))
                ) {
                } else {
                    console.log = function () {};
                }
            }
        }
        if (!window.debug) {
            document.addEventListener("contextmenu", function (e) {
                e.preventDefault();
            });
        }

        return (
            <Provider store={store}>
                <App />
            </Provider>
        );
    }
}

ReactDOM.render(<ReduxWrapper />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
